export const columnsToFilterByName = ['city', 'district', 'region'];
